import type VConsole from "vconsole";

import { isProduction } from "@/utils/constants";

export let vConsole: VConsole | null = null;

if (!isProduction) {
  await import("vconsole").then(({ default: VConsole }) => {
    const instance = new VConsole({
      onReady() {
        instance.hideSwitch();
      },
      target: document.body,
    });

    vConsole = instance;
  });
}
